import React from "react";
import "../../assets/css/--page-calendar.css";
import Hero from "./HeroSection";
import MenuCalendar from "./MenuCalendar";

export default function MonthlySpecial() {
  return (
    <>
      <Hero />
      <MenuCalendar />
    </>
  );
}
